import { itemsService } from '../services'

const getFormDeclaration = (id, type) => {
	return new Promise(resolve => {
		itemsService.getCDIForm(id, type)
			.then(response => resolve(response.data))
	})
}
export default getFormDeclaration
